var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-file',_vm._b({on:{"change":_vm.onFileSelected}},'ui-file',_vm.config,false),[_c('ui-button',{attrs:{"outlined":"","icon":"file_upload"}},[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }